import client from './client';

export interface PublicGalleryInfo {
  albumName: string;
  photoCount: number;
  hasPassword: boolean;
  expiresAt: string | null;
}

export interface PublicLinkConfig {
  token: string;
  expiresAt: string | null;
  hasPassword: boolean;
  createdAt: string;
}

export interface PublicPhoto {
  _id: string;
  thumbnailUrl: string;
  uploadedAt: string;
}

export const publicGalleryApi = {
  // ── Public routes (no auth) ────────────────────────────────────────────────
  getInfo: (token: string) =>
    client.get<PublicGalleryInfo>(`/public/${token}`).then((r) => r.data),

  verifyPin: (token: string, pin: string) =>
    client.post<{ accessToken: string }>(`/public/${token}/auth`, { pin }).then((r) => r.data),

  getPhotos: (
    token: string,
    opts?: { cursor?: string; accessToken?: string },
  ) =>
    client
      .get(`/public/${token}/photos`, {
        params: { cursor: opts?.cursor },
        headers: opts?.accessToken
          ? { Authorization: `Bearer ${opts.accessToken}` }
          : {},
      })
      .then(
        (r) =>
          r.data as {
            photos: PublicPhoto[];
            nextCursor: string | null;
            hasMore: boolean;
          },
      ),

  // ── Creator-side routes (auth required) ────────────────────────────────────
  getMyLink: (albumId: string) =>
    client
      .get<PublicLinkConfig | null>(`/albums/${albumId}/public-link`)
      .then((r) => r.data),

  createLink: (
    albumId: string,
    opts: { expiresInDays?: number; password?: string },
  ) =>
    client
      .post<PublicLinkConfig>(`/albums/${albumId}/public-link`, opts)
      .then((r) => r.data),

  revokeLink: (albumId: string) =>
    client.delete(`/albums/${albumId}/public-link`).then((r) => r.data),
};
